import { FontSizeType, FontWeightType } from './types';
import { styled } from 'next-yak';

const getFontSize = (size: FontSizeType) => {
  switch (size) {
    case 'sm':
      return '1.4rem';
    case 'md':
      return '1.6rem';
    case 'lg':
      return '1.8rem';
    case 'xl':
      return '2rem';
    case 'xxl':
      return '2.4rem';
    default:
      return '1.2rem';
  }
}

const getFontWeight = (weight: FontWeightType) => {
  switch (weight) {
    case 'medium':
      return 500;
    case 'bold':
      return 700;
    default:
      return 200;
  }
}

const getLineHeight = (size: FontSizeType) => {
  switch (size) {
    case 'sm':
      return '2rem';
    case 'md':
      return '2.4rem';
    case 'lg':
      return '2.8rem';
    case 'xl':
      return '3rem';
    case 'xxl':
      return '3.2rem';
    default:
      return '1.8rem';
  }
}

export const StyledText = styled.p<{
  color: string;
  size: FontSizeType;
  weight: FontWeightType;
}>`
  color: ${({ color }) => color ? `var(${color})` : 'var(--grey_600)'};

  font-size: ${({ size }) => getFontSize(size)};
  font-weight: ${({ weight }) => getFontWeight(weight)};
  line-height: ${({ size }) => getLineHeight(size)};

  margin: 0;
  padding: 0;
`;
